export default {
    groups: [
        {
            id: 1,
            label: 'Основные реквизиты',
            collapsed: false,
        },
        {
            id: 2,
            label: 'Статус',
            collapsed: false,
        },
        {
            id: 3,
            label: 'Общероссийские классификаторы',
            collapsed: false,
        },
        {
            id: 4,
            label: 'Адреса',
            collapsed: false,
        },
        {
            id: 5,
            label: 'ЕГРЮЛ',
            collapsed: false,
        },
        {
            id: 6,
            label: 'Договоры контрагента',
            collapsed: false,
        },
        {
            id: 7,
            label: 'Контрагент является грузополучателем, плательщиком или заинтересованным лицом в долгах',
            collapsed: false,
        },
    ],
    components: [
        // GROUP 1
        {
            name: 'component-name',
            groupId: 1,
            size: [1, 6],
            fieldKey: 'name'
        },
        {
            name: 'component-full-name',
            groupId: 1,
            size: [1, 6],
            fieldKey: 'acv_allname'
        },
        {
            name: 'component-inn',
            groupId: 1,
            size: [1, 1],
            fieldKey: 'inn'
        },
        {
            name: 'component-kpp',
            groupId: 1,
            size: [1, 1],
        },
        {
            name: 'component-rezident-rf',
            groupId: 1,
            size: [1, 1],
        },
        {
            name: 'component-kod-parent',
            groupId: 1,
            size: [1, 6],
        },
        // GROUP 2
        {
            name: 'component-change-status',
            groupId: 2,
            size: [1, 1],
        },
        {
            name: 'component-archive-date',
            groupId: 2,
            size: [1, 2],
        },
        // GROUP 3
        {
            name: 'component-okpo',
            groupId: 3,
            size: [1, 3],
        },
        {
            name: 'component-ogrn',
            groupId: 3,
            size: [1, 3],
        },
        {
            name: 'component-okato',
            groupId: 3,
            size: [1, 6],
        },
        {
            name: 'component-kod-fs',
            groupId: 3,
            size: [1, 6],
        },
        {
            name: 'component-kod-okved',
            groupId: 3,
            size: [1, 6],
        },
        // GROUP 4
        {
            name: 'component-adress-ur',
            groupId: 4,
            size: [1, 6],
        },
        {
            name: 'component-adress-pd',
            groupId: 4,
            size: [1, 6],
        },
        {
            name: 'component-adress',
            groupId: 4,
            size: [1, 6],
        },
        {
            name: 'component-adress-mail',
            groupId: 4,
            size: [1, 6],
        },
        {
            name: 'component-subtitle-adress-details',
            groupId: 4,
            size: [1, 6],
        },
        {
            name: 'component-mail-index',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-type-el-region',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-subject-rf',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-region-name',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-type-el-area',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-type-el-city',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-area-name',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-city-name',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-type-el-locality',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-type-el-street',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-locality-name',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-street-name',
            groupId: 4,
            size: [1, 3],
        },
        {
            name: 'component-adress-house',
            groupId: 4,
            size: [1, 2],
        },
        {
            name: 'component-adress-korp',
            groupId: 4,
            size: [1, 2],
        },
        {
            name: 'component-adress-office',
            groupId: 4,
            size: [1, 2],
        },
        // GROUP 5
        {
            name: 'component-egrul-subtitle',
            groupId: 5,
            size: [1, 6],
        },
        {
            name: 'component-egrul-kod',
            groupId: 5,
            size: [1, 4],
        },

        // {
        //   name: "component-egrul-cert-num",
        //   groupId: 5,
        //   size: [1, 3],
        // },
        {
            name: 'component-egrul-date',
            groupId: 5,
            size: [1, 2],
        },
        {
            name: 'component-egrul-organ',
            groupId: 5,
            size: [1, 6],
        },
        {
            name: 'component-egrul-data-subtitle',
            groupId: 5,
            size: [1, 6],
        },
        {
            name: 'component-egrul-status-name',
            groupId: 5,
            size: [1, 6],
        },
        {
            name: 'component-egrul-exclude-decision-date',
            groupId: 5,
            size: [1, 6],
        },
        {
            name: 'component-egrul-sulpd-name',
            groupId: 5,
            size: [1, 6],
        },
        {
            name: 'component-egrul-termination-date',
            groupId: 5,
            size: [1, 6],
        },
        {
            name: 'component-egrul-kod-ogrn',
            groupId: 5,
            size: [1, 2],
        },
        {
            name: 'component-egrul-date-connect-loc-reestr',
            groupId: 5,
            size: [1, 2],
        },
        {
            name: 'component-egrul-date-search-loc-reestr',
            groupId: 5,
            size: [1, 2],
        },
        // GROUP 6
        {
            name: 'component-abonents-contracts-kod-abonent-asuse',
            groupId: 6,
            size: [1, 1],
        },
        {
            name: 'component-abonents-contracts-contracts-grid',
            groupId: 6,
            size: [4, 6],
        },
        {
            name: 'component-abonents-contracts-abonent-grid',
            groupId: 7,
            size: [4, 6],
        },
        // {
        //   name: "component-kod-ecls",
        //   groupId: 6,
        //   size: [1, 2],
        // },
        // {
        //   name: "component-electro-market-class",
        //   groupId: 6,
        //   size: [1, 2],
        // },
    ],
};
